import { useEffect } from 'react'
import { useAppDispatch } from '../redux/hooks'
import { checkAuth } from '../redux/authenticator'

export const useAuthInit = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Check for existing Cognito session on app initialization
    dispatch(checkAuth())
  }, [dispatch])
}